import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';

const Content = styled.div`
  opacity: 0;
  transition: opacity 0.25s;
  transition-delay: 0.4s;

  &.is-visible {
    opacity: 1;
  }
`;

const FadeContent = ({ children }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return <Content className={visible ? 'is-visible' : ''}>{children}</Content>;
};

export default FadeContent;
